
function Step2Look({
 themeMode,
 setThemeMode,
 primaryColor,
 setPrimaryColor,
 accentColor,
 setAccentColor,
}) {
 return (
  <div className="card">
   <h2>Look</h2>



   <div className="row-2">
    <label className="field">
     <span>Theme</span>
     <select
      value={themeMode}
      onChange={(e) => setThemeMode(e.target.value)}
     >
      <option value="light">Light</option>
      <option value="dark">Dark</option>
     </select>
    </label>

    <label className="field">
     <span>Primary color</span>
     <input
      type="color"
      value={primaryColor}
      onChange={(e) => setPrimaryColor(e.target.value)}
     />
    </label>
   </div>

   <div className="row-2">

    <label className="field">
     <span>Accent color</span>
     <input
      type="color"
      value={accentColor}
      onChange={(e) => setAccentColor(e.target.value)}
     />
    </label>
   </div>
  </div>
 );
}

export default Step2Look;